/**
 * Legacy GTM dataLayer helper (category/action/page_source shape).
 *
 * Owner 2026-07: confirmed UNUSED — new guide-shaped events live in
 * helpers/ads/data-layer.js (pushPurchase, pushBeginCheckout, pushAddToCart,
 * pushGenerateLead, etc.). Dual-push was noise.
 *
 * Kept as a documented no-op so existing imports/call sites do not break.
 * Do not restore window.dataLayer.push here.
 */
const trackEventTagManager = (event, category, action, value, page_source) => {
  // no-op: legacy GTM event shape retired in favor of helpers/ads/data-layer.js
};


export {
  trackEventTagManager
};
